import { Component, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { QnSbnDataServiceService } from '../../services/qn-sbn-data-service.service';
import { OneWebComponentsAngularModule } from '@one/angular';
import { FileUploadSingleComponent } from '../file-upload/file-upload-single/file-upload-single.component';
import { CommonModule } from '@angular/common';
import { AppUtils } from '../../utlis/app-utils';
import { snackbarService } from '@one/web-components';

@Component({
  selector: 'dl-notification-doc',
  standalone: true,
  imports:[OneWebComponentsAngularModule,ReactiveFormsModule,FileUploadSingleComponent,CommonModule,FormsModule],
  templateUrl: './notification-doc.component.html',
  styleUrl: './notification-doc.component.scss',
  providers: [AppUtils],
})
export class NotificationDocComponent {

  // @ViewChild(MatSort, { static: true }) public sort: MatSort;
  // @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(FileUploadSingleComponent)
  private singleFileUploadComp: FileUploadSingleComponent;
  public fileData = [];
  public columnData: any;
  // public dataSource = new MatTableDataSource(ELEMENT_DATA);
  // public selection = new SelectionModel(true, []);
  public ELEMENT_DATA: any[] = []; // Use a simple array for data
  public selectedFiles: any[] = []; 
  public selectedRow: any; 
  public notificationTypeFormControl= new FormControl('');
  public userFileSize = { size: 0, type: '' };
  public notificationTypeList = [
    {
      label: 'SBN',
      value: 'Safety Board Notification',
      disabled: false
    },
    {
      label: 'QN',
      value: 'Quality Notification',
      disabled: false
    },
    {
      label: 'MN',
      value: 'Marketting Notification',
      disabled: false
    },
    {
      label: 'SN',
      value: 'Support Notification',
      disabled: false
    },
    {
      label: 'SNR',
      value: 'Support Notification with Risk',
      disabled: false
    }
  ];
  isTableShow: boolean = false;
  selectedData;
  count = 0;
  public documentEnabled: boolean;
  
  // Pagination properties
  public currentPage: number = 1;
  public pageSize: number = 5;
  public totalItems: number = 0;
  public totalPages: number = 0;
  private searchBaseUrl: string = '';

  public constructor(public appUtil: AppUtils,private qnsbnService: QnSbnService,private _QnSbnDataService:QnSbnDataServiceService) {
     this._QnSbnDataService.DocumentEnabled$.subscribe(
      res =>{
        this.documentEnabled = res;
      } 
    )
    // this.iconRegistry.addSvgIconLiteral('no_data_found', this.sanitizer.bypassSecurityTrustHtml(NO_DATA_FOUND_ICON));
  }
 
  public isDocumentAdded = true;
  public filesList = [];
  public files = [];
  public searchedItem = [];
  public allDraftData: any = {};
  public searchDocumentControl = new FormControl();
  public dataFlag: boolean = false;
  public isSearching: boolean = false;
  private isUpdatingDoc = false;
  public isDownloadTranslationEnabled: boolean = false;
  public ngOnInit() {
    this._QnSbnDataService.mappingData$.subscribe(observer=>{
      if(this.isUpdatingDoc) return;
      const notificationRowData = observer['notificationRowData'];
      const localNotificationData = observer['localNotificationId'];

      if (!this._QnSbnDataService.isEmpty(notificationRowData)) {
        this.allDraftData = notificationRowData;
      } else if (!this._QnSbnDataService.isEmpty(localNotificationData)) {
        this.allDraftData = localNotificationData;
      }

      if(!this._QnSbnDataService.isEmpty(observer['notificationDoc'])) {
        this.addSearchedDocument(observer['notificationDoc']);
      }

      this.updateDownloadTranslationButtonState();
      
      // this.dataTobestore = observer;
    })
  }

  ngAfterViewInit(): void {  
    // this.dataSource.paginator = this.paginator;
  }
  public addSearchedDocument(rowData: any,checkFromDelete?): void {
    this.selectedData = rowData;
    this.isTableShow = false;
    this.files.length = 0;
    const fileName = rowData['Title'] || rowData['FileName'] || '';
    const fileExt = rowData['FileExtension'] || (fileName.includes('.') ? fileName.split('.').pop() : '');
    const fileProperties = {
      name: fileName,
      size: rowData['FileSize'] || 0,
      fileIcon: fileExt === 'pdf' ? 'file_pdf' : 'file_word'
    };
    this.files.push(fileProperties);
    this.isDocumentAdded = true;
    this.searchDocumentControl.setValue('');
    this.notificationTypeFormControl.setValue('');
    this.addProduct(this.selectedData);
    checkFromDelete ? this.snackBarMessage('positive', 'Notification document successfully added') : false;
    this.updateDownloadTranslationButtonState();

    return;
  }
 
  onSearch() {
    let checkDocType = this.notificationTypeFormControl.value || '';
    this.searchBaseUrl = this.searchDocumentControl.value + "&documenttype=" + checkDocType;
    this.currentPage = 1;
    this.fetchPaginatedData(0);
  }

  private fetchPaginatedData(pageNumber: number): void {
    const url = this.searchBaseUrl + "&pageNumber=" + pageNumber + "&pageSize=" + this.pageSize;
    this.isSearching = true;
    this.isTableShow = true;
    
    this.qnsbnService.notificationDocPiosDocSearch(url).subscribe({
      next: (response: any) => {
        this.files.length = 0;
        const data = response.data || response;
        this.ELEMENT_DATA = data;
        this.dataFlag = Array.isArray(this.ELEMENT_DATA) && this.ELEMENT_DATA.length > 0;
        this.isSearching = false;
        this.isTableShow = true;
        
        // Update pagination from API response
        if (response.totalCount !== undefined) {
          this.totalItems = response.totalCount;
          this.totalPages = response.totalPages || Math.ceil(response.totalCount / this.pageSize);
          this.currentPage = (response.pageNumber || 0) + 1;
        } else {
          this.updatePagination();
        }
        
        this.ngAfterViewInit();
        if (this.singleFileUploadComp) {
          this.singleFileUploadComp.filesSingle.length = 0;
        }
        this.searchDocumentControl.setValue('');
        this.notificationTypeFormControl.setValue('');
      },
      error: (error) => {
        this.files.length = 0;
        this.ELEMENT_DATA = [];
        this.dataFlag = false;
        this.isSearching = false;
        this.isTableShow = true;
        this.totalItems = 0;
        this.totalPages = 0;
        this.ngAfterViewInit();
        if (this.singleFileUploadComp) {
          this.singleFileUploadComp.filesSingle.length = 0;
        }
        this.searchDocumentControl.setValue('');
        this.notificationTypeFormControl.setValue('');
        this.qnsbnService.httpErrorHandler(error, 'Please Select Notification Type');
      },
    });
  }

  // Pagination methods
  public updatePagination(): void {
    this.totalItems = this.ELEMENT_DATA ? this.ELEMENT_DATA.length : 0;
    this.totalPages = this.totalItems > 0 ? Math.ceil(this.totalItems / this.pageSize) : 0;
    if (this.totalPages === 0) {
      this.currentPage = 1;
    } else if (this.currentPage > this.totalPages) {
      this.currentPage = 1;
    }
  }

  public getPaginatedData(): any[] {
    if (!this.ELEMENT_DATA || this.ELEMENT_DATA.length === 0) {
      return [];
    }
    return this.ELEMENT_DATA;
  }

  public getStartIndex(): number {
    if (this.totalItems === 0) return 0;
    return (this.currentPage - 1) * this.pageSize;
  }

  public getEndIndex(): number {
    if (this.totalItems === 0) return 0;
    const endIndex = this.currentPage * this.pageSize;
    return Math.min(endIndex, this.totalItems);
  }

  public onPageSizeChange(): void {
    this.pageSize = Number(this.pageSize);
    this.currentPage = 1;
    if (this.searchBaseUrl) {
      this.fetchPaginatedData(0);
    }
  }

  public goToFirstPage(): void {
    if (this.currentPage !== 1) {
      this.currentPage = 1;
      this.fetchPaginatedData(0);
    }
  }

  public goToPreviousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.fetchPaginatedData(this.currentPage - 1);
    }
  }

  public goToNextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.fetchPaginatedData(this.currentPage - 1);
    }
  }

  public goToLastPage(): void {
    if (this.currentPage !== this.totalPages) {
      this.currentPage = this.totalPages;
      this.fetchPaginatedData(this.totalPages - 1);
    }
  }
  
  public addProduct(newData) {
    // console.log('New Data to be added:', newData); // Debug log to check the data being passed
    this.isUpdatingDoc = true;
    this._QnSbnDataService.getMappedQnsbnData(newData,"NotificationDoc");
    this.isUpdatingDoc = false;
    return;
 }

  public deleteFile(i, file) {
    this.files = this.files.filter(item => item !== file);
    const message = file.name + ' notification document successfully deleted';
    this.snackBarMessage('positive', message);
    if(this.files.length < 1){
      this.selectedData = '';
      this.addProduct(this.selectedData);
      this.isDownloadTranslationEnabled = false;
    }
  }

  public downloadDocument(fileName: string) {
    const isSavedFile = this.verifyGlobalDocument(fileName);
    if(isSavedFile) {
      const notificationDoc = this.allDraftData['NotificationDocuments'][0];
      if(notificationDoc.PIMID) {
        this.qnsbnService.downloadPiosDocumentApi(notificationDoc.PIMID, notificationDoc.FileExtension);
      } else {
        // Local file saved as notification document
        const notificationId = this.allDraftData['NotificationId'] || '';
        this.qnsbnService.downloadLocalAttachmentApi(fileName, notificationId);
      }
    } else {
      const notificationDocNew = this.selectedData;
      if(notificationDocNew?.PIMID) {
        this.qnsbnService.downloadPiosDocumentApi(notificationDocNew.PIMID, notificationDocNew.FileExtension);
      } else {
        this.snackBarMessage('alarm', 'File not yet saved. Please save the notification first.');
      }
    }  
  }

  public verifyGlobalDocument(fileName: string): boolean {
    const uploadedFiles = this.allDraftData['NotificationDocuments'] || [];
    const isSavedFile = uploadedFiles.some(fileItem => (fileItem.Title === fileName || fileItem.FileName === fileName));
    return isSavedFile;
  }

  private updateDownloadTranslationButtonState(): void {
    const translatedDoc = this.getTranslatedDocumentForSelectedNotification();
    if (!translatedDoc) {
      this.isDownloadTranslationEnabled = false;
      return;
    }

    const status = (translatedDoc?.Status || '').toString().trim().toLowerCase();
    this.isDownloadTranslationEnabled = status === 'done' && this.canDownloadTranslatedDocument(translatedDoc);
  }

  public onDownloadTranslation(): void {
    const translatedDoc = this.getTranslatedDocumentForSelectedNotification();
    if (!translatedDoc) {
      this.snackBarMessage('alarm', 'No translated document found for this notification document.');
      return;
    }

    const status = (translatedDoc?.Status || '').toString().trim().toLowerCase();
    if (status !== 'done') {
      this.snackBarMessage('alarm', 'Translated document is not ready yet.');
      return;
    }

    if (!this.canDownloadTranslatedDocument(translatedDoc)) {
      this.snackBarMessage('alarm', 'Translated document information is incomplete.');
      return;
    }

    this.qnsbnService.downloadTranslatedDocumentApi(translatedDoc);
  }

  private getTranslatedDocumentForSelectedNotification(): any {
    const translatedDocuments = this.allDraftData['TranslatedDocuments'];
    if (!Array.isArray(translatedDocuments) || translatedDocuments.length === 0) {
      return null;
    }

    const selectedPimid = this.selectedData?.PIMID || this.allDraftData?.['NotificationDocuments']?.[0]?.PIMID;
    if (selectedPimid) {
      const translatedForSelectedDoc = translatedDocuments.find((doc: any) => doc?.PIMID === selectedPimid);
      if (translatedForSelectedDoc) {
        return translatedForSelectedDoc;
      }
      return null;
    }

    return translatedDocuments[0];
  }

  private canDownloadTranslatedDocument(translatedDoc: any): boolean {
    const pimid = translatedDoc?.PIMID;
    const hasBucketAndKey = Boolean(translatedDoc?.Bucket && translatedDoc?.S3Key);
    const hasTargetLanguage = Boolean(this.getTargetLanguageCode(translatedDoc));
    return Boolean(pimid && (hasBucketAndKey || hasTargetLanguage));
  }

  private getTargetLanguageCode(translatedDoc: any): string {
    const rawTargetLanguage = translatedDoc?.TargetLanguage || translatedDoc?.TranslationTargetLanguage || translatedDoc?.Language;
    if (!rawTargetLanguage) {
      return '';
    }
    return String(rawTargetLanguage).trim().toLowerCase().split(/[_-]/)[0] || '';
  }

  ngOnDestroy(): void {
  }

  public bytesCalculation(bytes: number, decimals: number = 2): any {
    if (bytes === 0) {
      this.userFileSize.size = 0;
      this.userFileSize.type = '';
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    this.userFileSize.size = 0;
    this.userFileSize.type = '';

    this.userFileSize.size = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
    this.userFileSize.type = sizes[i];
    return this.userFileSize;
  }

  public formatBytes(bytes: number, decimals: number = 2): string {
    if (!bytes || bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const size = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
    return size + ' ' + sizes[i];
  }

  public updateDocumentEnabled(toggle){
    this._QnSbnDataService.setDocumentToggle(toggle);
    if(!toggle) {
      // Clear selected document data when disabled
      this.selectedData = '';
      this.files = [];
      this.isDownloadTranslationEnabled = false;
      this.addProduct({});
    }
  }

  snackBarMessage(status:any,message:string){
      snackbarService.show({
        message: message, 
        snackbarProps: {
          status: status,
          direction: 'horizontal',
          showClose: true,
          elevated: false,
          duration: 5000,
          verticalPlacement: 'top',
          horizontalPlacement: 'right',
        }
      });
    }

}let ELEMENT_DATA = [];
